module.exports = __webpack_public_path__ + "static/media/picture-quiz-speech-sound.9d5a995f.mp3";